import * as yup from 'yup';
import errorMessages from "protocol-setup/constants/errorMessages";

const { openSetupForm } = errorMessages.openRave;

const ancillaryStudySchema = yup.object({
  psOpenAncillaryId: yup
    .number()
    .nullable(),
  groupProtocolNumber: yup
    .string()
    .max(100, openSetupForm.ancillaryStudy.groupProtocolNumber.max)
    .required(openSetupForm.ancillaryStudy.groupProtocolNumber.required),
  stepNumber: yup
    .number()
    .typeError(openSetupForm.ancillaryStudy.stepNumber.typeError)
    .transform((value, originalValue) => {
      return originalValue === '' ? undefined : value
    })
    .min(1, openSetupForm.ancillaryStudy.stepNumber.min)
    .max(99, openSetupForm.ancillaryStudy.stepNumber.max)
    .required(openSetupForm.ancillaryStudy.stepNumber.required),
  mandatory: yup
    .string()
    .oneOf(["MANDATORY", "OPTIONAL"])
    .required(openSetupForm.ancillaryStudy.mandatory.required)
});

const irocDetailsSchema = yup.object({
  psOpenIrocId: yup.number()
    .nullable(),
  type: yup
    .string()
    .max(100, openSetupForm.irocDetails.type.max)
    .required(openSetupForm.irocDetails.type.required),
  requirement: yup
    .string()
    .oneOf(["MANDATORY", "OPTIONAL", "MANDATORY_AT_LEAST_ONE"])
    .required(openSetupForm.irocDetails.requirement.required)
});

const stepSchema = yup.object({
  psOpenStepId: yup
    .number()
    .nullable(),
  required: yup
    .boolean(openSetupForm.step.required.required)
    .required(openSetupForm.step.required.required),
  publicFormIds: yup
    .string()
    .max(100, openSetupForm.step.publicFormIds.max)
    .required(openSetupForm.step.publicFormIds.required),
  crfVersionNum: yup
    .string()
    .max(100, openSetupForm.step.crfVersionNum.max)
    .required(openSetupForm.step.crfVersionNum.required),
  stepNumber: yup
    .string()
    .max(2, openSetupForm.step.stepNumber.max)
    .required(openSetupForm.step.stepNumber.required),
  stepDescription: yup
    .string()
    .max(100, openSetupForm.step.stepDescription.max)
    .required(openSetupForm.step.stepDescription.required),
  initialization: yup
    .boolean(openSetupForm.step.boolSelect.required)
    .required(openSetupForm.step.boolSelect.required),
  registrationType: yup
    .string()
    .required(openSetupForm.step.boolSelect.required),
  transferEcData: yup
    .boolean(openSetupForm.step.boolSelect.required)
    .required(openSetupForm.step.boolSelect.required),
  markForDownload: yup
    .boolean(openSetupForm.step.boolSelect.required)
    .required(openSetupForm.step.boolSelect.required)
});

const formSchema = yup.object({
  psOpenId: yup.number()
    .nullable(),
  isStandardRandoNodeUrl: yup
    .boolean(openSetupForm.isStandardRandoNodeUrl.required)
    .required(openSetupForm.isStandardRandoNodeUrl.required),
  randoNodeUrl: yup
    .string()
    .max(200, openSetupForm.randoNodeUrl.max)
    .when('isStandardRandoNodeUrl', ([isStandardRandoNodeUrl], schema) => {
      return isStandardRandoNodeUrl === false
        ? schema.required(openSetupForm.randoNodeUrl.required)
        : schema.notRequired();
    }),
  isEmbeddedAncillaryStudy: yup
    .boolean(openSetupForm.isEmbeddedAncillaryStudy.required)
    .required(openSetupForm.isEmbeddedAncillaryStudy.required),
  protSetupAncillaryStudies: yup
    .array()
    .of(ancillaryStudySchema)
    .default([]),
  isSlotReservationProtocol: yup
    .boolean(openSetupForm.isSlotReservationProtocol.required)
    .required(openSetupForm.isSlotReservationProtocol.required),
  slotReservationSteps: yup
    .string()
    .when('isSlotReservationProtocol', ([isSlotReservationProtocol], schema) => {
      return isSlotReservationProtocol === true
        ? schema
            .required(openSetupForm.slotReservationSteps.required)
            .test(
              "is-comma-separated-two-digit-numbers",
              openSetupForm.slotReservationSteps.test,
              value => {
                if (!value) return false;
                return value
                  .split(',')
                  .every(v => /^\d{1,2}$/.test(v.trim()));
              }
            )
        : schema.notRequired();
    }),
  isIrocCredentialingInfoOpen: yup
    .boolean(openSetupForm.isIrocCredentialingInfoOpen.required)
    .required(openSetupForm.isIrocCredentialingInfoOpen.required),
  protSetupIrocDetails: yup
    .array()
    .of(irocDetailsSchema)
    .default([]),
  protSetupStepDetails: yup
    .array()
    .of(stepSchema)
    .default([]),
  requestedTestSites: yup
    .string()
    .max(100, openSetupForm.requestedTestSites.max)
    .required(openSetupForm.requestedTestSites.required),
  additionalSetupNotes: yup
    .string()
    .max(1000, openSetupForm.additionalSetupNotes.max)
    .notRequired()
});


export { formSchema, ancillaryStudySchema, irocDetailsSchema, stepSchema };
